import { FormTemplateViews } from "./form-input-template.component";

// stringify version
// "{\"views\":{\"ticketSummary\":{\"header\":\"Ticket Summary\",\"key\":\"ticketSummary\",\"groups\":{\"companyInfo\":{\"header\":\"Company Info\",\"key\":\"companyInfo\",\"groupOrder\":1,\"fields\":{\"ExcavatorName\":{\"inputTypeID\":13,\"label\":\"Company Name\",\"key\":\"ExcavatorName\",\"placeholder\":\"Company Name\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":100,\"fieldOrder\":1,\"isVisible\":true,\"options\":{\"hasValues\":false,\"optionsFillID\":1,\"patchValues\":[{\"viewKey\":\"companyInfo\",\"controlKeys\":[\"ContactName\",\"ExcavatorName\",\"ExcavatorCity\",\"Email\",\"ExcavatorAddress\",\"PhoneNumber\"]}]}}}},\"worksite\":{\"header\":\"Work Site\",\"key\":\"worksite\",\"groupOrder\":2,\"fields\":{\"worksiteAddress\":{\"inputTypeID\":14,\"label\":\"Worksite Address\",\"key\":\"worksiteAddress\",\"placeholder\":\"Search worksite address\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":100,\"fieldOrder\":1,\"isVisible\":true}}},\"details\":{\"header\":\"Details\",\"key\":\"details\",\"groupOrder\":3,\"fields\":{\"utilities\":{\"inputTypeID\":12,\"label\":\"utilities\",\"key\":\"utilities\",\"placeholder\":\"utilities\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":100,\"fieldOrder\":1,\"isVisible\":true,\"options\":{\"hasValues\":false,\"optionsFillID\":2}}}},\"schedule\":{\"header\":\"Schedule\",\"key\":\"schedule\",\"groupOrder\":4,\"fields\":{\"AvailableRigs\":{\"inputTypeID\":11,\"label\":\"Available Rigs\",\"key\":\"AvailableRigs\",\"placeholder\":\"Choose rig\",\"matches\":\"\",\"isRequired\":false,\"isReadOnly\":false,\"width\":100,\"fieldOrder\":1,\"isVisible\":true,\"options\":{\"hasValues\":false,\"optionsFillID\":4}}}}}},\"companyInfo\":{\"header\":\"Company Info\",\"key\":\"companyInfo\",\"groups\":{\"companyDetails\":{\"header\":\"Company Details\",\"key\":\"companyDetails\",\"groupOrder\":1,\"fields\":{\"ExcavatorName\":{\"inputTypeID\":13,\"label\":\"Company Name\",\"key\":\"ExcavatorName\",\"placeholder\":\"Enter Company Name\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":100,\"fieldOrder\":1,\"isVisible\":true,\"options\":{\"hasValues\":false,\"optionsFillID\":1,\"patchValues\":[{\"viewKey\":\"companyInfo\",\"controlKeys\":[\"ContactName\",\"ExcavatorName\",\"ExcavatorCity\",\"Email\",\"ExcavatorAddress\",\"PhoneNumber\"]},{\"viewKey\":\"ticketSummary\",\"controlKeys\":[\"ExcavatorName\"]}]}},\"ExcavatorAddress\":{\"inputTypeID\":2,\"label\":\"Company Address\",\"key\":\"ExcavatorAddress\",\"placeholder\":\"Enter Company Address\",\"matches\":\"\",\"isRequired\":false,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":2,\"isVisible\":true},\"ExcavatorCity\":{\"inputTypeID\":2,\"label\":\"Company City\",\"key\":\"ExcavatorCity\",\"placeholder\":\"Enter Company City\",\"matches\":\"\",\"isRequired\":false,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":3,\"isVisible\":true}}},\"contactDetails\":{\"header\":\"Contact Details\",\"key\":\"contactDetails\",\"groupOrder\":2,\"fields\":{\"ContactName\":{\"inputTypeID\":2,\"label\":\"Contact Name\",\"key\":\"ContactName\",\"placeholder\":\"Enter Contact Name\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":1,\"isVisible\":true},\"Email\":{\"inputTypeID\":2,\"label\":\"Contact Email\",\"key\":\"Email\",\"placeholder\":\"contactemail@gmail.com\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":2,\"isVisible\":true},\"PhoneNumber\":{\"inputTypeID\":2,\"label\":\"Contact Phone Number\",\"key\":\"PhoneNumber\",\"placeholder\":\"5193334444\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":3,\"isVisible\":true}}}}},\"details\":{\"header\":\"Details\",\"key\":\"details\",\"groups\":{\"ticketDetails\":{\"header\":\"Ticket Details\",\"key\":\"ticketDetails\",\"groupOrder\":1,\"fields\":{\"TypeOfWork\":{\"inputTypeID\":2,\"label\":\"TypeOfWork\",\"key\":\"TypeOfWork\",\"placeholder\":\"TypeOfWork\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":1,\"isVisible\":true,\"options\":{\"hasValues\":false,\"optionsFillID\":1}},\"OriginalExcavationDate\":{\"inputTypeID\":10,\"label\":\"Start Date\",\"key\":\"OriginalExcavationDate\",\"placeholder\":\"Start Date\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":2,\"isVisible\":true},\"Remarks\":{\"inputTypeID\":2,\"label\":\"Remarks\",\"key\":\"Remarks\",\"placeholder\":\"Remarks\",\"matches\":\"\",\"isRequired\":false,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":3,\"isVisible\":true},\"PONum\":{\"inputTypeID\":2,\"label\":\"PO Number\",\"key\":\"PONum\",\"placeholder\":\"0\",\"matches\":\"\",\"isRequired\":false,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":4,\"isVisible\":true},\"JobNumber\":{\"inputTypeID\":2,\"label\":\"Job Number\",\"key\":\"JobNumber\",\"placeholder\":\"0\",\"matches\":\"\",\"isRequired\":false,\"isReadOnly\":false,\"width\":50,\"fieldOrder\":5,\"isVisible\":true}}},\"utilities\":{\"header\":\"Utilities\",\"key\":\"utilities\",\"groupOrder\":2,\"fields\":{\"utilities\":{\"inputTypeID\":12,\"label\":\"utilities\",\"key\":\"utilities\",\"placeholder\":\"utilities\",\"matches\":\"\",\"isRequired\":true,\"isReadOnly\":false,\"width\":100,\"fieldOrder\":1,\"isVisible\":true,\"options\":{\"hasValues\":false,\"optionsFillID\":2}}}}}}}}"
export const DEFAULT_FORM_TEMPLATE = {
  views: [
    {
      header: "Ticket Summary",
      key: "ticketSummary",
      groups: [
        {
          header: "Company Information",
          key: "company-info",
          groupOrder: 1,
          fields: [
            {
              inputTypeID: 13,
              label: "Company Name",
              key: "ExcavatorName",
              placeholder: "Enter Company Name",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              fieldOrder: 1,
              width: 100,
              options: {
                hasValues: false,
                optionsFillID: 1,
                autoFillFields: ["ContactName"],
                values: [
                  {
                    text: "stringText",
                    value: "stringVal",
                  },
                  {
                    text: "stringText1",
                    value: "stringVal1",
                  },
                  {
                    text: "stringText2",
                    value: "stringVal2",
                  },
                  {
                    text: "stringText13",
                    value: "stringVal14",
                  },
                ],
              },
            },
            {
              inputTypeID: 13,
              label: "Contact Name",
              key: "ContactName",
              placeholder: "Enter Contact Name",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 2,
              width: 100,
              options: {
                hasValues: true,
                optionsFillID: 1,
                values: [
                  {
                    text: "te",
                    value: "stringVal",
                  },
                  {
                    text: "tesx5",
                    value: "stringVal1",
                  },
                  {
                    text: "eeee",
                    value: "stringVal2",
                  },
                  {
                    text: "344543f",
                    value: "stringVal14",
                  },
                ],
              },
            },
          ],
        },
        {
          header: "Work Site",
          key: "worksite",
          groupOrder: 2,
          fields: [
            {
              inputTypeID: 2,
              label: "Full Address",
              key: "address",
              placeholder: "Enter Address",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 1,
              width: 100,
            },
          ],
        },
        {
          header: "Ticket Details",
          key: "details",
          groupOrder: 3,
          fields: [
            {
              inputTypeID: 2,
              label: "Type of Work",
              key: "typeOfWork",
              placeholder: "Enter Type of Work",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 1,
              width: 100,
            },
            {
              inputTypeID: 2,
              label: "Excavation Date",
              key: "excavationDate",
              placeholder: "Enter Excavation Date",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 2,
              width: 100,
            },
            {
              inputTypeID: 2,
              label: "Select Utility",
              key: "utilities",
              placeholder: "Select Utilities",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 3,
              width: 100,
            },
          ],
        },
        {
          header: "Schedule",
          key: "schedule",
          groupOrder: 4,
          fields: [
            {
              inputTypeID: 2,
              label: "Schedule Date Start",
              key: "schedStartDate",
              placeholder: "Enter start date",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 1,
              width: 100,
            },
            {
              inputTypeID: 2,
              label: "Schedule Date End",
              key: "schedEndDate",
              placeholder: "Enter end date",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 2,
              width: 100,
            },
            {
              inputTypeID: 2,
              label: "Available Rigs",
              key: "rigs",
              placeholder: "Select Available Rigs",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 3,
              width: 100,
            },
            {
              inputTypeID: 2,
              label: "User Responsible",
              key: "userResponsible",
              placeholder: "Select User Responsible",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 4,
              width: 100,
            },
            {
              inputTypeID: 2,
              label: "Users",
              key: "users",
              placeholder: "Select Users",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 5,
              width: 100,
            },
          ],
        },
      ],
    },
    {
      header: "Company Information",
      key: "company-info",
      groups: [
        {
          header: "Company Details",
          key: "companyDetails",
          groupOrder: 1,
          fields: [
            {
              inputTypeID: 2,
              label: "Search Company Name",
              key: "ExcavatorName",
              placeholder: "Search Company Name",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              fieldOrder: 1,
              width: 100,
            },
            {
              inputTypeID: 2,
              label: "Company City",
              key: "ExcavatorCity",
              placeholder: "Enter Company City",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              fieldOrder: 2,
              width: 50,
            },
            {
              inputTypeID: 2,
              label: "Company Address",
              key: "ExcavatorAddress",
              placeholder: "Enter Company Address",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              fieldOrder: 3,
              width: 50,
            },
          ],
        },
        {
          header: "Contact Details",
          key: "contactDetails",
          groupOrder: 2,
          fields: [
            {
              inputTypeID: 2,
              label: "Contact Name",
              key: "ContactName",
              placeholder: "Enter Contact Name",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              fieldOrder: 1,
              width: 50,
            },
            {
              inputTypeID: 2,
              label: "Contact Email",
              key: "Email",
              placeholder: "Enter Contact Email",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 1,
              width: 50,
            },
            {
              inputTypeID: 2,
              label: "Contact Number",
              key: "contactNumber",
              placeholder: "Enter Contact Number",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 3,
              width: 50,
            },
          ],
        },
      ],
    },
    {
      header: "Ticket Details",
      key: "details",
      groups: [
        {
          header: "Work Details",
          key: "workDetails",
          groupOrder: 1,
          fields: [
            {
              inputTypeID: 2,
              label: "Type of Work",
              key: "typeOfWork",
              placeholder: "Enter Type of Work",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 1,
              width: 50,
            },
            {
              inputTypeID: 2,
              label: "Excavation Date",
              key: "excavationDate",
              placeholder: "Enter Excavation Date",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 2,
              width: 50,
            },
            {
              inputTypeID: 2,
              label: "Select Utility",
              key: "utilities",
              placeholder: "Select Utilities",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              fieldOrder: 3,
              width: 100,
            },
          ],
        },
      ],
    },
  ],
};

export const DEFAULT_FORM_TEMPLATE_OBJECT: FormTemplateViews = {
  views: {
    ticketSummary: {
      header: "Ticket Summary",
      key: "ticketSummary",
      groups: {
        companyInfo: {
          header: "Customer Details",
          key: "companyInfo",
          groupOrder: 1,
          fields: {
            ExcavatorName: {
              inputTypeID: 13,
              appearance: "fill",
              label: "Customer Name",
              key: "ExcavatorName",
              placeholder: "Customer Name",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 100,
              width_lg: 100,
              width_xl: 100,
              fieldOrder: 1,
              isVisible: true,
              options: {
                hasValues: false,
                optionsFillID: 1,
                patchValues: [
                  {
                    viewKey: "companyInfo",
                    controlKeys: [
                      "ContactName",
                      "ExcavatorName",
                      "ExcavatorCity",
                      "Email",
                      "ExcavatorAddress",
                      "PhoneNumber",
                    ],
                  },
                ],
              },
            },
          },
        },
        worksite: {
          header: "Work Site",
          key: "worksite",
          groupOrder: 2,
          fields: {
            worksiteAddress: {
              inputTypeID: 14,
              appearance: "fill",
              label: "Search Worksite Address",
              key: "worksiteAddress",
              placeholder: "Search worksite address",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 100,
              width_lg: 100,
              width_xl: 100,
              fieldOrder: 1,
              isVisible: true,
              options: {
                hasValues: false,
                patchValues: [
                  {
                    viewKey: "ticketSummary",
                    controlKeys: [
                      "StartHouseNumber",
                      "LocateAddress",
                      "LocateSubRegionName",
                    ],
                  },
                ],
              },
            },
            StartHouseNumber: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Street No",
              key: "StartHouseNumber",
              placeholder: "Street No",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 100,
              width_lg: 100,
              width_xl: 100,
              fieldOrder: 2,
              isVisible: true,
            },
            LocateAddress: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Street Address",
              key: "LocateAddress",
              placeholder: "Street Address",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 100,
              width_lg: 100,
              width_xl: 100,
              fieldOrder: 3,
              isVisible: true,
            },
            LocateSubRegionName: {
              inputTypeID: 2,
              appearance: "fill",
              label: "City",
              key: "LocateSubRegionName",
              placeholder: "City",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 100,
              width_lg: 100,
              width_xl: 100,
              fieldOrder: 4,
              isVisible: true,
            },
          },
        },
        details: {
          header: "Details",
          key: "details",
          groupOrder: 3,
          fields: {
            utilities: {
              inputTypeID: 12,
              appearance: "fill",
              label: "utilities",
              key: "utilities",
              placeholder: "utilities",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 100,
              width_lg: 100,
              width_xl: 100,
              fieldOrder: 1,
              isVisible: true,
              options: {
                hasValues: false,
                optionsFillID: 2,
              },
            },
            OriginalExcavationDate: {
              inputTypeID: 10,
              appearance: "fill",
              label: "Excavation Date",
              key: "OriginalExcavationDate",
              placeholder: "Excavation Date",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 100,
              width_lg: 100,
              width_xl: 100,
              fieldOrder: 2,
              isVisible: true,
              options: {
                hasValues: false,
                patchValues: [
                  {
                    viewKey: "ticketSummary",
                    controlKeys: ["EventStartDateTime", "EventEndDateTime"],
                  },
                  {
                    viewKey: "details",
                    controlKeys: ["OriginalExcavationDate"],
                  },
                ],
              },
            },
          },
        },
      },
    },
    companyInfo: {
      header: "Customer Details",
      key: "companyInfo",
      groups: {
        companyDetails: {
          header: "Customer Details",
          key: "companyDetails",
          groupOrder: 1,
          fields: {
            ExcavatorName: {
              inputTypeID: 13,
              appearance: "fill",
              label: "Customer Name",
              key: "ExcavatorName",
              placeholder: "Enter Customer Name",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 1,
              isVisible: true,
              options: {
                hasValues: false,
                optionsFillID: 1,
                patchValues: [
                  {
                    viewKey: "companyInfo",
                    controlKeys: [
                      "ContactName",
                      "ExcavatorName",
                      "ExcavatorCity",
                      "Email",
                      "ExcavatorAddress",
                      "PhoneNumber",
                    ],
                  },
                  {
                    viewKey: "ticketSummary",
                    controlKeys: ["ExcavatorName"],
                  },
                ],
              },
            },
            ExcavatorAddress: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Customer Address",
              key: "ExcavatorAddress",
              placeholder: "Enter Customer Address",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 2,
              isVisible: true,
            },
            ExcavatorCity: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Customer City",
              key: "ExcavatorCity",
              placeholder: "Enter Customer City",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 3,
              isVisible: true,
            },
          },
        },
        contactDetails: {
          header: "Contact Details",
          key: "contactDetails",
          groupOrder: 2,
          fields: {
            ContactName: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Contact Name",
              key: "ContactName",
              placeholder: "Enter Contact Name",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 1,
              isVisible: true,
            },
            Email: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Contact Email",
              key: "Email",
              placeholder: "contactemail@gmail.com",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 2,
              isVisible: true,
            },
            PhoneNumber: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Contact Phone Number",
              key: "PhoneNumber",
              placeholder: "5193334444",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 3,
              isVisible: true,
            },
          },
        },
      },
    },
    details: {
      header: "Details",
      key: "details",
      groups: {
        ticketDetails: {
          header: "Ticket Details",
          key: "ticketDetails",
          groupOrder: 1,
          fields: {
            TypeOfWork: {
              inputTypeID: 2,
              appearance: "fill",
              label: "TypeOfWork",
              key: "TypeOfWork",
              placeholder: "TypeOfWork",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 1,
              isVisible: true,
              options: {
                hasValues: false,
                optionsFillID: 1,
              },
            },
            CallDate: {
              inputTypeID: 10,
              appearance: "fill",
              label: "Call Date",
              key: "CallDate",
              placeholder: "",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 2,
              isVisible: true,
            },
            OriginalExcavationDate: {
              inputTypeID: 10,
              appearance: "fill",
              label: "Excavation Date",
              key: "OriginalExcavationDate",
              placeholder: "Excavation Date",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 3,
              isVisible: true,
              options: {
                hasValues: false,
                patchValues: [
                  {
                    viewKey: "ticketSummary",
                    controlKeys: ["OriginalExcavationDate"],
                  },
                ],
              },
            },
            Remarks: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Remarks",
              key: "Remarks",
              placeholder: "Remarks",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 4,
              isVisible: true,
            },
            ExtentOfWork: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Extent of Work",
              key: "ExtentOfWork",
              placeholder: "",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 5,
              isVisible: true,
            },
            PONum: {
              inputTypeID: 2,
              appearance: "fill",
              label: "PO Number",
              key: "PONum",
              placeholder: "0",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 6,
              isVisible: true,
            },
            JobNumber: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Job Number",
              key: "JobNumber",
              placeholder: "0",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 7,
              isVisible: true,
            },
            bSiteMeetRequired: {
              inputTypeID: 1,
              appearance: "fill",
              label: "Site Meet Required",
              key: "bSiteMeetRequired",
              placeholder: "",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 8,
              isVisible: true,
            },
            MeetLocation: {
              inputTypeID: 2,
              appearance: "fill",
              label: "Meet Location/Information",
              key: "MeetLocation",
              placeholder: "",
              matches: "",
              isRequired: false,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 50,
              width_lg: 33,
              width_xl: 25,
              fieldOrder: 9,
              isVisible: true,
            },
          },
        },
        utilities: {
          header: "Utilities",
          key: "utilities",
          groupOrder: 2,
          fields: {
            utilities: {
              inputTypeID: 12,
              appearance: "fill",
              label: "utilities",
              key: "utilities",
              placeholder: "utilities",
              matches: "",
              isRequired: true,
              isReadOnly: false,
              width_xs: 100,
              width_sm: 100,
              width_md: 100,
              width_lg: 100,
              width_xl: 100,
              fieldOrder: 1,
              isVisible: true,
              options: {
                hasValues: false,
                optionsFillID: 2,
              },
            },
          },
        },
      },
    },
  },
};

// export const DEFAULT_FORM_TEMPLATE_SCHEDULE_OBJECT:FormTemplateViews = {
//   "views": {
//     "ticketSummary": {
//       "header":"Ticket Summary",
//       "key":"ticketSummary",
//       "groups": {
//         "companyInfo": {
//           "header":"Company Info",
//           "key":"companyInfo",
//           "groupOrder":1,
//           "fields": {
//             "ExcavatorName":{
//               "inputTypeID": 13,
//               "label": "Company Name",
//               "key": "ExcavatorName",
//               "placeholder": "Company Name",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":1,
//               "isVisible":true,
//               "options": {
//                 "hasValues":false,
//                 "optionsFillID":1,
//                 "patchValues": [
//                   {
//                     "viewKey":"companyInfo",
//                     "controlKeys":["ContactName", "ExcavatorName", "ExcavatorCity", "Email", "ExcavatorAddress", "PhoneNumber"]
//                   }
//                 ]
//               }
//             }
//           }
//         },
//         "worksite": {
//           "header":"Work Site",
//           "key":"worksite",
//           "groupOrder":2,
//           "fields": {
//             "worksiteAddress":{
//               "inputTypeID": 14,
//               "label": "Search Worksite Address",
//               "key": "worksiteAddress",
//               "placeholder": "Search worksite address",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":1,
//               "isVisible":true,
//               "options": {
//                 "hasValues":false,
//                 "patchValues": [{
//                   "viewKey":"ticketSummary",
//                   "controlKeys":["StartHouseNumber", "LocateAddress", "LocateSubRegionName"]
//                 }]
//               }
//             },
//             "StartHouseNumber":{
//               "inputTypeID": 2,
//               "label": "Street No",
//               "key": "StartHouseNumber",
//               "placeholder": "Street No",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":2,
//               "isVisible":true
//             },
//             "LocateAddress":{
//               "inputTypeID": 2,
//               "label": "Street Address",
//               "key": "LocateAddress",
//               "placeholder": "Street Address",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":3,
//               "isVisible":true
//             },
//             "LocateSubRegionName":{
//               "inputTypeID": 2,
//               "label": "City",
//               "key": "LocateSubRegionName",
//               "placeholder": "City",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":4,
//               "isVisible":true
//             }
//           }
//         },
//         "details": {
//           "header":"Details",
//           "key":"details",
//           "groupOrder":3,
//           "fields": {
//             "utilities":{
//               "inputTypeID": 12,
//               "label": "utilities",
//               "key": "utilities",
//               "placeholder": "utilities",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":1,
//               "isVisible":true,
//               "options": {
//                 "hasValues":false,
//                 "optionsFillID":2
//               }
//             },
//             "OriginalExcavationDate":{
//               "inputTypeID": 10,
//               "label": "Excavation Date",
//               "key": "OriginalExcavationDate",
//               "placeholder": "Excavation Date",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":2,
//               "isVisible":true,
//               "options": {
//                 "hasValues":false,
//                 "patchValues": [{
//                   "viewKey":"ticketSummary",
//                   "controlKeys":["EventStartDateTime", "EventEndDateTime"]
//                 },
//                 {
//                   "viewKey":"details",
//                   "controlKeys":["OriginalExcavationDate"]
//                 }]
//               }
//             }
//           }
//         },
//         "schedule": {
//           "header":"Schedule",
//           "key":"schedule",
//           "groupOrder":4,
//           "fields": {
//             "EventStartDateTime": {
//               "inputTypeID": 10,
//               "label": "Start Date",
//               "key": "EventStartDateTime",
//               "placeholder": "Event Start Date",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":1,
//               "isVisible":true
//             },
//             "EventEndDateTime": {
//               "inputTypeID": 10,
//               "label": "End Date",
//               "key": "EventEndDateTime",
//               "placeholder": "Event End Date",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":2,
//               "isVisible":true
//             },
//             "AvailableRigs": {
//               "inputTypeID": 11,
//               "label": "Available Rigs",
//               "key": "AvailableRigs",
//               "placeholder": "Choose rig",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":3,
//               "isVisible":true
//             }
//           }
//         }
//       }
//     },
//     "companyInfo": {
//       "header":"Company Info",
//       "key":"companyInfo",
//       "groups": {
//         "companyDetails": {
//           "header":"Company Details",
//           "key":"companyDetails",
//           "groupOrder":1,
//           "fields": {
//             "ExcavatorName":{
//               "inputTypeID": 13,
//               "label": "Company Name",
//               "key": "ExcavatorName",
//               "placeholder": "Enter Company Name",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":1,
//               "isVisible":true,
//               "options": {
//                 "hasValues":false,
//                 "optionsFillID":1,
//                 "patchValues": [
//                   {
//                     "viewKey":"companyInfo",
//                     "controlKeys":["ContactName", "ExcavatorName", "ExcavatorCity", "Email", "ExcavatorAddress", "PhoneNumber"]
//                   },
//                   {
//                     "viewKey":"ticketSummary",
//                     "controlKeys":["ExcavatorName"]
//                   }
//                 ]
//               }
//             },
//             "ExcavatorAddress":{
//               "inputTypeID": 2,
//               "label": "Company Address",
//               "key": "ExcavatorAddress",
//               "placeholder": "Enter Company Address",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":2,
//               "isVisible":true
//             },
//             "ExcavatorCity":{
//               "inputTypeID": 2,
//               "label": "Company City",
//               "key": "ExcavatorCity",
//               "placeholder": "Enter Company City",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":3,
//               "isVisible":true
//             }
//           }
//         },
//         "contactDetails": {
//           "header":"Contact Details",
//           "key":"contactDetails",
//           "groupOrder":2,
//           "fields": {
//             "ContactName":{
//               "inputTypeID": 2,
//               "label": "Contact Name",
//               "key": "ContactName",
//               "placeholder": "Enter Contact Name",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":1,
//               "isVisible":true
//             },
//             "Email":{
//               "inputTypeID": 2,
//               "label": "Contact Email",
//               "key": "Email",
//               "placeholder": "contactemail@gmail.com",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":2,
//               "isVisible":true
//             },
//             "PhoneNumber":{
//               "inputTypeID": 2,
//               "label": "Contact Phone Number",
//               "key": "PhoneNumber",
//               "placeholder": "5193334444",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":3,
//               "isVisible":true
//             }
//           }
//         }
//       }
//     },
//     "details": {
//       "header":"Details",
//       "key":"details",
//       "groups": {
//         "ticketDetails": {
//           "header":"Ticket Details",
//           "key":"ticketDetails",
//           "groupOrder":1,
//           "fields": {
//             "TypeOfWork":{
//               "inputTypeID": 2,
//               "label": "TypeOfWork",
//               "key": "TypeOfWork",
//               "placeholder": "TypeOfWork",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":1,
//               "isVisible":true,
//               "options": {
//                 "hasValues":false,
//                 "optionsFillID":1
//               }
//             },
//             "OriginalExcavationDate":{
//               "inputTypeID": 10,
//               "label": "Excavation Date",
//               "key": "OriginalExcavationDate",
//               "placeholder": "Excavation Date",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":2,
//               "isVisible":true,
//               "options": {
//                 "hasValues":false,
//                 "patchValues": [{
//                   "viewKey":"ticketSummary",
//                   "controlKeys":["OriginalExcavationDate", "EventStartDateTime", "EventEndDateTime"]
//                 }]
//               }
//             },
//             "Remarks": {
//               "inputTypeID": 2,
//               "label": "Remarks",
//               "key": "Remarks",
//               "placeholder": "Remarks",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":3,
//               "isVisible":true
//             },
//             "PONum": {
//               "inputTypeID": 2,
//               "label": "PO Number",
//               "key": "PONum",
//               "placeholder": "0",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":4,
//               "isVisible":true
//             },
//             "JobNumber": {
//               "inputTypeID": 2,
//               "label": "Job Number",
//               "key": "JobNumber",
//               "placeholder": "0",
//               "matches": "",
//               "isRequired": false,
//               "isReadOnly": false,
//               "width": 50,
//               "fieldOrder":5,
//               "isVisible":true
//             }
//           }
//         },
//         "utilities": {
//           "header":"Utilities",
//           "key":"utilities",
//           "groupOrder":2,
//           "fields": {
//             "utilities":{
//               "inputTypeID": 12,
//               "label": "utilities",
//               "key": "utilities",
//               "placeholder": "utilities",
//               "matches": "",
//               "isRequired": true,
//               "isReadOnly": false,
//               "width": 100,
//               "fieldOrder":1,
//               "isVisible":true,
//               "options": {
//                 "hasValues":false,
//                 "optionsFillID":2
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// }
